import React from 'react';

import LogoPurple from 'components/no-auth/header-fixed/LogoPurple';

import clsx from 'clsx';

import styles from './Footer.module.css';

export default function FooterLogo(props) {
    const logoClass = clsx(styles.logoContainer, {
        [styles.logoContainerBlack]: props.promoDarkPage,
    });

    return (
        <div className={logoClass}>
            <LogoPurple lang={props.lang} country={props.country} />
        </div>
    );
}
